/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PermalinkViewContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ConversationThreadContainer_viewer" | "ReplyListContainer1_viewer" | "UserBoxContainer_viewer" | "CreateCommentMutation_viewer" | "CreateCommentReplyMutation_viewer">;
    readonly " $refType": "PermalinkViewContainer_viewer";
};
export type PermalinkViewContainer_viewer$data = PermalinkViewContainer_viewer;
export type PermalinkViewContainer_viewer$key = {
    readonly " $data"?: PermalinkViewContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PermalinkViewContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PermalinkViewContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ConversationThreadContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBoxContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreateCommentMutation_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CreateCommentReplyMutation_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '076b2df4af774da47b24ab47bef6149b';
export default node;
